import { PoWiseOpCompletionModel } from "./po-wise-op-completion.model";


export class DayWiseOpCompletionModel {
    plannedDate: string;
    poWiseCompletionStatus: PoWiseOpCompletionModel[];
}